import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useMemo } from "react";
import { Box } from "@mui/material";
import _default from "../../vendor/react-input-autosize/lib/AutosizeInput.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import { spreadSx } from "../../utils/spreadSx.js";
import cn from "../../vendor/classnames/index.js";
const VALIDATION_ERROR_CLASSNAME = "input-validation-error", Input = forwardRef(
  ({ error, sx, inputRef, size = "xs", ...props }, ref) => {
    const internalInputRef = useRef(null), containerStyles = useMemo(
      () => [styles.container, sizeStyles[size], ...spreadSx(sx)],
      [size, sx]
    );
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(error && VALIDATION_ERROR_CLASSNAME),
        ref,
        sx: containerStyles,
        component: _default,
        "data-test-id": DATA_TEST_ID_INHERITED,
        ...props,
        inputRef: (el) => {
          for (const reference of [internalInputRef, inputRef])
            typeof reference == "function" ? reference(el) : reference && (reference.current = el);
        }
      }
    );
  }
);
Input.displayName = "CounterInput";
const styles = {
  container: {
    [`&.${VALIDATION_ERROR_CLASSNAME}`]: {
      input: {
        borderColor: (t) => t.palette.field.regularbg.border.error,
        outlineColor: (t) => t.palette.field.regularbg.border.error,
        borderWidth: 2,
        "@media(hover:hover)": {
          "&:hover:not(:disabled)": {
            borderColor: (t) => t.palette.field.regularbg.border.error
          }
        },
        "&:focus": {
          borderColor: (t) => t.palette.field.regularbg.border.error,
          outlineWidth: 0
        }
      }
    },
    input: {
      textAlign: "center",
      paddingX: 4,
      maxWidth: 100,
      minWidth: (t) => t.sizes.common.xxl - 10,
      fontFamily: (t) => t.typography.fontFamily ?? "",
      fontSize: "14px",
      border: (t) => `1px solid ${t.palette.field.border.default}`,
      outlineColor: (t) => t.palette.field.border.default,
      outlineWidth: 0,
      outlineStyle: "solid",
      "@media(hover:hover)": {
        "&:hover:not(:disabled)": {
          borderColor: (t) => t.palette.field.border.hover
        }
      },
      "&:focus": {
        outlineColor: (t) => t.palette.field.border.active,
        borderColor: (t) => t.palette.field.border.active,
        outlineWidth: 1
      },
      "&:disabled": {
        bgcolor: (t) => t.palette.field.regularbg.bg.disabled,
        color: (t) => t.palette.field.regularbg.inputuser.disabled
      }
    }
  }
}, sizeStyles = {
  xs: {
    input: {
      lineHeight: "28px"
    }
  },
  md: {
    input: {
      lineHeight: "40px"
    }
  }
};
export {
  Input
};
//# sourceMappingURL=Input.js.map
